import React from "react";
import { ReactComponent as BOOTSTRAP } from "../img/skill_icons/bootstrap.svg";

export const Bootstrap = () => {
  return <BOOTSTRAP title="bootstrap" />;
};
